export const persianMessages = { //todo: handle english
  '4000': 'شماره تلفن همراه تنها باید از رقم تشکیل شده باشد.',
  '4001': 'شماره تلفن همراه باید حداقل ۱۰ رقم داشته باشد.',

  '4002': 'کد تایید باید ۵ رقم داشته باشد.',
  '4003': 'شماره تلفن همراه یا کد تایید نامعتبر است.',
  '4004': 'کاربری با این شماره تلفن قبلاً ثبت‌نام کرده است.',
  '4005': 'کد تایید منقضی شده است.',
  '4006': 'کاربری با این مشخصات وجود ندارد.',
  '4007': 'اطلاعاتی وجود ندارد.',
  '4008': 'کاربری با این شماره‌تلفن همراه وجود ندارد.',
  '4009': 'اطلاعات وارد شده صحیح نیست.',
  '4010': 'این مدرسه هنوز تایید نشده است.',
  '4011': 'این کاربر پیش از این یک مشخصات دانش‌آموزی دارد.',
  '4012': 'grade must be between 0 and 12',
  '4013': 'major is required for high school students',
  '4014': 'non-high school students can\'t have major',
  '4015': 'college students must enter their studying degree',
  '4016': 'given condition has syntax error',
  '4017': 'given number was not a positive integer',
  '4018': 'price must be a multiple of 500 Tomans',
  '4019': 'number of selected choices can\'t be bigger than max choices for this problem',
  '4020': 'selected choices can\'t have repetitions',
  '4021': 'selected choices should be indices of choices',
  '4022': 'a registration form must belong only to an event or fsm not both',
  '4023': 'event already has a registration form',
  '4024': 'fsm already has a registration form',
  '4025': 'registration form must belong to an event or fsm, neither is provided',
  '4026': 'you can\'t edit this entity you are not one of it\'s modifiers',
  '4027': 'provided answer is to a problem not present in this paper',
  '4028': 'پیش از این به فرم ثبت نام پاسخ داده‌ای.',
  '4029': 'به همه‌ی سوالات اجباری پاسخ ندادی!',
  '4030': 'selected choices should be from corresponding problems',
  '4031': 'only institutes\'s admins can create events',
  '4032': 'پایه‌ی تحصیلی شما برای ثبت‌نام در این کلاس مجاز نیست.',
  '4033': 'لطفاً پایه‌ی تحصیلی‌ات را در پروفایل مشخص کن.',
  '4034': 'you must have an active school studentship to register',
  '4035': 'event is full',
  '4036': 'deadline for registration is missed',
  '4037': 'percentage numbers must be between zero and one',
  '4038': 'given discount code doesn\'t belong to this user',
  '4039': 'given discount code has a merchandise, no merchandise provided',
  '4040': 'this discount code is not for this merchandise',
  '4041': 'given code is expired',
  '4042': 'given code is not valid, (maybe used)',
  '4043': 'given merchandise is not active',
  '4044': 'you haven\'t registered for this event/fsm',
  '4045': 'you registration has not been accepted yet for this event/fsm',
  '4046': 'you have already purchased this merchandise successfully',
  '4047': 'this file answer has already been associated with a problem',
  '4048': 'you can\'t make others\' answers a solution to your own problems, not here & not in real life',
  '4049': 'you can\'t submit others\' answers to your problems',
  '4050': 'you can\'t make a team when you are not registered / not accepted / not paid',
  '4051': 'you already have an active team membership, you can\'t create a new team unless you don\'t have any active team membership',
  '4052': 'given registration receipt (user) does not belong to this team\'s event / fsm',
  '4053': 'این کاربر در حال حاضر عضو تیمی است.',
  '4054': 'شما پیش از این، کاربر مورد نظر را به گروه خود دعوت کرده‌اید.',
  '4055': 'فرم ثبت‌نام این کاربر تایید نشده است.',
  '4056': 'you can\'t revoke an accepted invitation',
  '4057': 'اطلاعات بخش دانش‌آموزی ناقص است!',
  '4058': 'you must provide your gender',
  '4059': 'team member capacity is full',
  '4060': 'only team heads can revoke invitations',
  '4061': 'only registration form modifiers can validate receipts',
  '4062': 'user\'s document is not verified yet',
  '4063': 'no invitee data is given',
  '4064': 'no team is given',
  '4065': 'کاربری با این مشخصات وجود ندارد.',
  '4066': 'you can\'t create discount code for a merchandise you don\'t own',
  '4067': 'neither username nor user_id is given',
  '4068': 'only admin can export data',
  '4069': 'fsms inside events can\'t have merchandise or registration forms',
  '4070': 'fsm holder should be the same as event holder',
  '4071': 'fsm_p_type must be the same as event type (hybrid & team are the same)',
  '4072': 'team size must be the same as event team size',
  '4073': 'creator must be a modifier of event in order to add fsm to event',
  '4074': 'team based event must have team_size > 0 and vise versa',
  '4075': 'you are not this fsm\'s mentor, only mentors can add or edit states, edges & widgets ',
  '4076': 'tail & head of an edge must be from same fsms',
  '4077': 'fsm can\'t have registration form when its event has registration form too',
  '4078': 'user has no team, it\'s unavailable to enter team based fsms without team',
  '4079': 'no valid registration found for given fsm / event',
  '4080': 'invalid key',
  '4081': 'player history not found',
  '4082': 'player not found',
  '4083': 'player current state and edge tail/head must be the same to move forward/backward on edge',
  '4084': 'other teammates are already trying to move you to next state',
  '4085': 'edge / fsm is locked',
  '4086': 'invalid move',
  '4087': 'unable to move on a hidden edge, only mentors can move you on hidden edges, contact them!',
  '4088': 'no one in this team has entered this fsm',
  '4089': 'فقط سرگروه می‌تواند تیم را حرکت دهد.',



  '5000': 'ارسال پیامک با خطا روبه‌رو شد.',
  '5001': 'zarinpal request failed, contact with support',
  '5002': 'given registration form is illegal, a form must either associate with an event or a fsm',
  '5003': 'given merchandise is illegal, a merch must be either for an event or a fsm',
  '5004': 'each event/fsm must have a registration form, given one doesn\'t'
}